import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { Button } from "@/components/ui/button";
import { Download, ShoppingBag, Gift, CheckCircle, Package } from "lucide-react";

export default function Loja() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero */}
      <section className="pt-24 bg-brand-primary py-14 sm:py-20">
        <div className="container mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-white/15 text-white/90 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wide uppercase">
            <ShoppingBag className="w-3.5 h-3.5" />
            Materiais & Produtos
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-primary mb-4 leading-tight">
            Loja de Produtos
          </h1>
          <p className="text-white/75 text-base sm:text-lg max-w-2xl mx-auto font-primary">
            Materiais gratuitos, e-books e produtos selecionados para sua jornada de saúde
          </p>
        </div>
      </section>

      {/* E-book em destaque */}
      <section className="py-14">
        <div className="container mx-auto px-6 max-w-3xl">
          <div className="rounded-2xl overflow-hidden shadow-lg flex flex-col sm:flex-row">
            {/* painel verde */}
            <div className="bg-brand-primary sm:w-56 sm:shrink-0 flex flex-col items-center justify-center p-8 gap-4">
              <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center">
                <Gift className="w-8 h-8 text-white" />
              </div>
              <p className="text-white font-bold font-primary text-center text-sm leading-snug">E-book Gratuito</p>
            </div>

            {/* conteúdo branco */}
            <div className="bg-white flex-1 p-7">
              <h2 className="text-xl font-bold font-primary text-gray-800 mb-1">
                Guia de Nutrição e Bem-Estar
              </h2>
              <p className="text-sm text-gray-500 mb-4 leading-relaxed">
                Baixe gratuitamente e descubra como transformar sua relação com a alimentação.
              </p>

              <ul className="space-y-2 mb-6">
                {[
                  "Fundamentos da nutrição equilibrada",
                  "Como criar hábitos alimentares sustentáveis",
                  "Dicas práticas para o dia a dia",
                  "Receitas saudáveis e deliciosas",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-gray-600">
                    <CheckCircle className="w-4 h-4 text-brand-primary shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>

              <Button className="bg-brand-primary hover:bg-brand-primary/90 font-primary font-semibold shadow-md">
                <Download className="w-4 h-4 mr-2" />
                Baixar E-book Gratuito
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Produtos em breve */}
      <section className="py-14 border-t border-gray-100">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="text-center mb-10">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Em breve</p>
            <h2 className="text-2xl font-bold font-primary text-gray-800 mb-2">Mais Produtos a Caminho</h2>
            <p className="text-gray-500 text-sm max-w-xl mx-auto">
              Estamos preparando uma seleção especial de produtos e serviços para você.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 opacity-50 flex flex-col items-center text-center gap-3">
                <div className="w-14 h-14 bg-brand-primary/8 rounded-xl flex items-center justify-center">
                  <Package className="w-7 h-7 text-brand-primary/40" />
                </div>
                <p className="text-sm font-semibold text-gray-400 font-primary">Produto em Breve</p>
                <p className="text-xs text-gray-300">Aguarde novidades incríveis…</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
}
